import { memo } from 'react';
import { MemberAddTemplate } from 'components/templates/MemberAddTemplate';

type Props = {};

export const MemberAdd = memo((_props: Props) => {
	return <MemberAddTemplate />;
});
